import { render, staticRenderFns } from "./AllowedCurrency.vue?vue&type=template&id=2021e936"
import script from "./AllowedCurrency.vue?vue&type=script&lang=js"
export * from "./AllowedCurrency.vue?vue&type=script&lang=js"
import style0 from "./AllowedCurrency.vue?vue&type=style&index=0&id=2021e936&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports